import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { BeneficiaryDto } from './dto/beneficiary.dto';

@Component({
  template: '',
  standalone: false,
})
export abstract class BeneficiaryBaseComponent implements OnDestroy {
  public beneficiary: BeneficiaryDto;
  protected readonly destroy$: Subject<void> = new Subject();

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
